var b2h = [];
var h2b = {};
for(var i = 0; i < 256; i++) {
	b2h[i] = (i + 0x100).toString(16).substr(1);
	h2b[i] = i;
}

export var bufferToString = function(buff) {
	return  b2h[buff[3]] + b2h[buff[2]] +
			b2h[buff[1]] + b2h[buff[0]] + '-' +
			b2h[buff[5]] + b2h[buff[4]] + '-' +
			b2h[buff[7]] + b2h[buff[6]] + '-' +
			b2h[buff[8]] + b2h[buff[9]] + '-' +
			b2h[buff[10]] + b2h[buff[11]] +
			b2h[buff[12]] + b2h[buff[13]] +
			b2h[buff[14]] + b2h[buff[15]];
};

export var stringToBuffer = function(str) {
	str = str.replace(/-/g, '');
	return new Buffer(str.substring(6, 8) +
		str.substring(4, 6) +
		str.substring(2, 4) +
		str.substring(0, 2) +
		str.substring(10, 12) +
		str.substring(8, 10) +
		str.substring(14, 16) +
		str.substring(12, 14) +
		str.substring(16, 18) +
		str.substring(18, 20) +
		str.substring(20, 22) +
		str.substring(22, 24) +
		str.substring(24, 26) +
		str.substring(26, 28) +
		str.substring(28, 30) +
		str.substring(30, 32), 'hex');
};

export var s4 = function() {
	return Math.floor((1 + Math.random()) * 0x10000)
		.toString(16)
		.substring(1)
		.toUpperCase();
};

export var newGUID = function() {
	return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
		s4() + '-' + s4() + s4() + s4();
};

export var isGUID = function(str) {
	var regex  = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
	if(str instanceof Buffer)
		str = bufferToString(str);
	return str.match(regex) ? true : false;
};
